var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButton2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.662,
    height: 21.952,
    viewBox: "0 0 17.662 21.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6120",
    "data-name": "Group 6120",
    transform: "translate(1379.333 91.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3076",
    "data-name": "Rectangle 3076",
    width: 4.761,
    height: 16.662,
    rx: 1,
    transform: "translate(-1378.833 -70.388) rotate(-90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8671",
    "data-name": "Path 8671",
    d: "M3.4-3.471,5.34-5.062C6.5-6,7.719-7.2,7.719-8.8c0-1.727-1.428-2.815-3.332-2.815a3.7,3.7,0,0,0-3.3,1.754l1.061.884a2.46,2.46,0,0,1,2.149-1.333A1.75,1.75,0,0,1,6.224-8.652c0,1.02-.775,1.754-1.89,2.679L1.247-3.417v1.278H7.815V-3.566Z",
    transform: "translate(-1374.951 -80.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3120",
    "data-name": "Rectangle 3120",
    d: "M0,0H2A1,1,0,0,1,3,1V7.9a1,1,0,0,1-1,1H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(-1375.026 -75.217) rotate(-90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton2);
export default __webpack_public_path__ + "static/media/button2.9ee6e635.svg";
export { ForwardRef as ReactComponent };